import { Box, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import { Column } from 'common/components/Table/CommonTableStyles';
import TableComponent from 'common/components/Table/Table';
import { RootState } from 'common/store/AppStore';
import {
	setSelectedMyApprovalItem,
	setApprovalDrawerState,
	setApprovalDrawerTabState,
} from 'common/store/reducer/commonReducer';

import useTableQuery from 'hooks/useTableQuery';

import ApprovalDrawer from './MyApprovalDrawer/ApprovalDrawer';

import styles from './MyApprovals.module.scss';

interface IMyApprovalTableProps {
	isLoading: boolean;
	id: string;
	data: any;
	fetchData: (data: any) => Promise<void>;
	pageCount: number;
}
const MyApprovalsTable = (items: IMyApprovalTableProps) => {
	const { isLoading, id, data, fetchData, pageCount } = items;
	const dispatch = useDispatch();

	const { tableQueryObj: tableProps, updateTableQuery } = useTableQuery({ id });
	const selectedlistItem = useSelector(
		(state: RootState) => state.common.selectedMyApprovalItem,
	);
	const isApprovalDrawerOpen = useSelector(
		(state: RootState) => state.common.isApprovalDrawerOpen,
	);
	const isApprovalDrawerTabIndex = useSelector(
		(state: RootState) => state.common.isApprovalDrawerTabIndex,
	);
	const handlePageChange = (data: any, flag?: boolean) => {
		if (flag) {
			fetchData(data);
			updateTableQuery(data);
		}
	};

	const handleSortChange = (data: any) => {
		fetchData(data);
	};

	const handleNameClick = (item: any) => {
		dispatch(setSelectedMyApprovalItem(item));
		dispatch(setApprovalDrawerState(true));
		dispatch(setApprovalDrawerTabState(0));
	};

	const handleChangesClick = (item: any) => {
		dispatch(setSelectedMyApprovalItem(item));

		dispatch(setApprovalDrawerState(true));
		dispatch(setApprovalDrawerTabState(1));
	};

	const columns: readonly Column[] = [
		{
			id: 'name',
			label: 'Name',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<Typography
					data-testid="approval-name-btn"
					onClick={() => handleNameClick(params)}
					className={styles['name-text']}
				>
					{params.name}
				</Typography>
			),
		},
		{
			id: 'displayId',
			label: 'id',
			disablePadding: false,
			isSortable: false,
		},
		{
			id: 'type',
			label: 'Type',
			disablePadding: false,
			isSortable: false,
		},
		{
			id: 'changeCount',
			label: 'Changes',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<Typography
					className={styles['changes-text']}
					onClick={() => handleChangesClick(params)}
					style={{ cursor: 'pointer' }}
				>{`${params.changeCount} Changes`}</Typography>
			),
		},
	];

	const handleDrawerClose = () => {
		dispatch(setApprovalDrawerState(false));
		fetchData(tableProps);
	};

	return (
		<Box
			className={styles['data-ingestion-landing-box']}
			data-testid="dataIngestionTable"
		>
			<TableComponent
				defaultQuery={tableProps}
				rows={data}
				columns={columns}
				totalItems={pageCount}
				defaultSortKey=""
				defaultSortDirection="desc"
				onPageHandler={handlePageChange}
				isLoading={isLoading}
				tableStyles={{ minWidth: '46.875em', maxHeight: '46.875em' }}
				onSortHandler={handleSortChange}
				enableHeaderColor
				isRenderPagination
			/>
			<SideDrawer
				className={styles['save-drawer']}
				drawerState={isApprovalDrawerOpen}
			>
				<ApprovalDrawer
					data={selectedlistItem}
					onClose={handleDrawerClose}
					defaultTab={isApprovalDrawerTabIndex}
				/>
			</SideDrawer>
		</Box>
	);
};

export default MyApprovalsTable;
